import { menuSection } from "modules/helpers";
import overview from "./overview";
import api from "./api";
import auth from "./auth";
import builders from "./builders";
import data from "./data";
import formatters from "./formatters";
import forms from "./forms";
import layout from "./layout";
import logging from "./logging";
import lookups from "./lookups";
import menus from "./menus";
import modals from "./modals";
import navigation from "./navigation";
import notifications from "./notifications";
import pagination from "./pagination";
import preferences from "./preferences";
import routing from "./routing";
import signalr from "./signalr";
import tables from "./tables";
import tiles from "./tiles";
import utility from "./utility";

export default [
  menuSection("Overview", "overview", overview),
  menuSection("API", "api", api),
  menuSection("Auth", "auth", auth),
  menuSection("Builders", "builders", builders),
  menuSection("Data", "data", data),
  menuSection("Formatters", "formatters", formatters),
  menuSection("Forms", "forms", forms),
  menuSection("Layout", "layout", layout),
  menuSection("Logging", "logging", logging),
  menuSection("Lookups", "lookups", lookups),
  menuSection("Menus", "menus", menus),
  menuSection("Modals", "modals", modals),
  menuSection("Navigation", "navigation", navigation),
  menuSection("Notifications", "notifications", notifications),
  menuSection("Pagination", "pagination", pagination),
  menuSection("Preferences", "preferences", preferences),
  menuSection("Routing", "routing", routing),
  menuSection("SignalR", "signalr", signalr),
  menuSection("Tables", "tables", tables),
  menuSection("Tiles", "tiles", tiles),
  menuSection("Utility", "utility", utility),
];
